/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h6 has text inside
    if ($(this).text() != '') {
          //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.product-single__accordion.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.product-single__accordion.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><div class="product-single__accordion__title-wrapper"><h3 class="product-single__accordion__title-text u-large f-family--body">' + tabName + '</h3><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></div></a>');
      } else {  
          //hide empty H6
          $(this).hide();
      }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
});

// Notify Me popup logic (no styles, just behavior)
document.addEventListener('DOMContentLoaded', function() {
  // Open popup on click
  $(document).on('click', '.js-product-notify', function(e) {
    e.preventDefault();

    var $btn = $(this);
    var sectionId = $btn.data('section-id');
    var $popup = $('.js-notify-draw-' + sectionId);

    if ($popup.length === 0) return false;

    // Populate dynamic fields
    // IMPORTANT: use dataset instead of jQuery .data() to avoid stale cached values
    var el = this;
    var ds = el.dataset || {};
    var productTitle = ds.productTitle || '';
    var variantTitle = ds.variantTitle || '';
    var variantId = ds.variantId || '';
  var variantGid = ds.variantGid || '';
    var variantSize = ds.variantSize || '';

    $popup.find('.js-notify-product').text(productTitle);
    $popup.find('.js-notify-variant').text(variantTitle);
    $popup.find('input[name="product_title"]').val(productTitle);
    $popup.find('input[name="variant_title"]').val(variantTitle);
    $popup.find('input[name="variant_id"]').val(variantId);
    if (variantGid) {
      $popup.find('input[name="variant_gid"]').val(variantGid);
    }
    if (variantSize) {
      $popup.find('input[name="variant_size"]').val(variantSize);
      // If you want to show size separately in text, append to variant text
      var variantText = variantTitle;
      if (variantText && variantSize && variantText.toLowerCase().indexOf(variantSize.toLowerCase()) === -1) {
        variantText = variantText + ' · ' + variantSize;
      }
      $popup.find('.js-notify-variant').text(variantText || variantSize);
    }

    // Open via existing theme popup helper
    if (window.theme && typeof theme.mfpOpen === 'function') {
      // Use generic inline open for custom block: reuse product-popup case API
      $.magnificPopup.open({
        items: { src: $popup },
        type: 'inline',
        mainClass: 'mfp-medium',
        fixedContentPos: true,
        closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp" aria-label="close"><i class="icon icon--close-l"></i></button>',
        removalDelay: 200
      });
    }

    return false;
  });

  // Notify form submit: validate, show spinner, then success state
  $(document).on('submit', '.js-notify-form', function(e) {
    e.preventDefault();
    var $form = $(this);
    var $btn = $form.find('.js-notify-submit');
    // Localized messages from data attributes (fallback to English)
    var msgs = {
      invalidEmail: $form.data('error-invalid-email') || 'Please enter a valid email.',
      generic: $form.data('error-generic') || 'Something went wrong. Please try again.',
      network: $form.data('error-network') || 'Network error. Please try again.'
    };

    // Clear previous errors
    $form.find('.form-error').remove();
    $form.find('input.form-field--error').removeClass('form-field--error');

    // Basic email validation
    var $email = $form.find('input[name="email"]');
    var emailVal = ($email.val() || '').trim();
    var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
    if (!emailValid) {
      $email.addClass('form-field--error');
      $('<div class="form-error" role="alert"></div>').text(msgs.invalidEmail).insertAfter($email);
      return;
    }

    if ($btn.length) {
      $btn.addClass('is-adding').prop('disabled', true);
    }

    // Prepare payload to create/update customer via App Proxy backend
    var nameVal = ($form.find('input[name="name"]').val() || '').trim();
    var productTitle = ($form.find('input[name="product_title"]').val() || '').trim();
    var variantTitle = ($form.find('input[name="variant_title"]').val() || '').trim();
    var variantId = ($form.find('input[name="variant_id"]').val() || '').trim();
    var variantGid = ($form.find('input[name="variant_gid"]').val() || '').trim();
    var variantSize = ($form.find('input[name="variant_size"]').val() || '').trim();
    if (!variantGid && variantId) {
      // Fallback: construct GID if hidden field wasn't populated for some reason
      variantGid = 'gid://shopify/ProductVariant/' + variantId;
    }

    var tags = ['notify-restock'];
    if (productTitle) tags.push('product:' + productTitle);
    if (variantTitle) tags.push('variant:' + variantTitle);
    if (variantId) tags.push('variant_id:' + variantId);
    if (variantSize) tags.push('size:' + variantSize);
    var tagsStr = tags.join(', ');

    // Build payload for backend
    var payload = {
      email: emailVal,
      name: nameVal,
      product_title: productTitle,
      variant_title: variantTitle,
      variant_id: variantId,
      variant_gid: variantGid,
      variant_size: variantSize,
      tags: tagsStr
    };

  // Submit to App Proxy endpoint which forwards to Cloudflare Worker
  // NOTE: Storefront App Proxy subpath now is /apps/notify
  fetch('/apps/notify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function(res) {
        // Robustly parse response: prefer JSON, but gracefully fall back to text/empty
        var ct = (res.headers.get('content-type') || '').toLowerCase();
        return res.text().then(function(text) {
          if (ct.indexOf('application/json') > -1) {
            try {
              return JSON.parse(text);
            } catch (e) {
              // If the server mislabeled content-type or sent HTML, avoid throwing
              return { ok: res.ok, parseError: 'invalid_json', raw: text };
            }
          }
          // Not JSON — return a minimal shape the UI can handle
          return { ok: res.ok, raw: text };
        });
      })
      .then(function(data) {
        // If backend returns ok/success, show success. Otherwise show error.
        var success = false;
        if (data && (data.ok === true || data.success === true)) success = true;
        // Treat empty text/HTML responses with HTTP 200 as success
        if (!success && data && typeof data.ok !== 'undefined') success = !!data.ok;

        if (success) {
          var $inner = $form.closest('.notify-draw__inner');
          // swap to success state
          $inner.find('.notify-draw__form').hide();
          $inner.find('.notify-draw__success').removeAttr('hidden').show();

          // auto-close after 2.5s
          var closeTimer = setTimeout(function() {
            if ($.magnificPopup && $.magnificPopup.instance && $.magnificPopup.instance.isOpen) {
              $.magnificPopup.close();
            }
          }, 2500);
          $inner.data('notifySuccessTimer', closeTimer);
        } else {
          // Show a non-blocking error under the email field
          $('<div class="form-error" role="alert"></div>').text(msgs.generic).insertAfter($email);
        }
      })
      .catch(function() {
        // Network or unexpected error
        $('<div class="form-error" role="alert"></div>').text(msgs.network).insertAfter($email);
      })
      .finally(function() {
        if ($btn.length) {
          $btn.removeClass('is-adding').prop('disabled', false);
        }
      });
  });

  // Reset form/success state when popup closes
  $(document).on('mfpClose', function() {
    $('.js-notify-draw').each(function() {
      var $popup = $(this);
      // clear pending auto-close timer if any
      var $inner = $popup.find('.notify-draw__inner');
      var t = $inner.data('notifySuccessTimer');
      if (t) {
        clearTimeout(t);
        $inner.removeData('notifySuccessTimer');
      }
      var $form = $popup.find('.js-notify-form');
      if ($form.length && $form[0]) {
        $form[0].reset();
      }
      $popup.find('.form-error').remove();
      $popup.find('input.form-field--error').removeClass('form-field--error');
      $popup.find('.notify-draw__success').attr('hidden', true).hide();
      $popup.find('.notify-draw__form').show();
      $popup.find('.js-notify-submit').removeClass('is-adding').prop('disabled', false);
    });
  });
// Add bell icon class to numeric size labels (e.g. 55, 56, 57)
  (function markNumericSizeLabels() {
    var labels = document.querySelectorAll('.product-form__swatch__label');
    labels.forEach(function(label) {
      var text = (label.textContent || '').trim();
      if (!text) return;

      var num = parseInt(text, 10);
      if (!isNaN(num) && num >= 30 && num <= 80) {
        label.classList.add('product-form__swatch__label--size');
      }
    });
  })();
});